/** 사용자가 마지막으로 고른 응시 모드를 기억합니다 (브라우저별, 실패해도 기본값으로 동작). */
export type ExamMode = 'practice' | 'exam';

const KEY = 'examMode';

export const readExamMode = (): ExamMode => {
  try {
    return localStorage.getItem(KEY) === 'practice' ? 'practice' : 'exam';
  } catch {
    return 'exam';
  }
};

export const saveExamMode = (mode: ExamMode) => {
  try {
    localStorage.setItem(KEY, mode);
  } catch {
    // 저장소를 쓸 수 없어도 선택은 이번 화면에서 유지됩니다.
  }
};
